import { useContext, useEffect, useState } from "react";
import { UserContext } from "../storage/contexts/UserContext";

import { FaRegTrashCan } from "react-icons/fa6";
import axios from "axios";
import {
  DELETE_SUPPORT_PERSON,
  GET_MANAGERS_TEAM,
  REMOVE_TEAM_MEMBER,
} from "../Routes";
import EventBus from "../storage/EventBus";
import { generateURLOptions } from "../URLOptions";

const UserManageTeamModal = ({ isOpen, onClose }) => {
  const { profile } = useContext(UserContext);

  const [team, setTeam] = useState([]);

  useEffect(() => {
    if (isOpen) getTeamMembers();
  }, [isOpen]);

  const getTeamMembers = async () => {
    try {
      const response = await axios.get(GET_MANAGERS_TEAM, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      setTeam(response?.data?.data);
    } catch (error) {
      console.error("Get Team Members: ", error);
      return alert(error);
    }
  };

  const removeTeamMember = async (person) => {
    try {
      const response = await axios.post(
        REMOVE_TEAM_MEMBER,
        {
          person: person?._id,
        },
        {
          headers: generateURLOptions(),
        },
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getTeamMembers();
    } catch (error) {
      console.error("Remove Team Member: ", error);
      return alert(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300">
      <div className="bg-white rounded-xl w-full max-w-sm mx-4 p-6 shadow-xl transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-start">
          <h4 className="text-xl font-semibold text-left mb-2">Manage Team</h4>

          {team?.map((person, index) => (
            <div
              key={index}
              className="w-full flex flex-row justify-start items-center border-indigo-600 border text-black py-2 pl-2 pr-3 rounded-xl mb-2"
            >
              <img
                className="h-10 w-10 object-cover rounded-full"
                src={person?.profileImage ?? ""}
              />
              <div className="flex flex-col ml-3">
                <p className="font-medium text-base">
                  {person?.firstname ?? ""} {person?.lastname ?? ""}
                </p>
                <p className="font-normal text-xs">Team Member</p>
              </div>

              <div style={{ flex: 1 }} />
              <div
                className="cursor-pointer"
                onClick={() => removeTeamMember(person)}
              >
                <FaRegTrashCan color="#ff0000" />
              </div>
            </div>
          ))}

          <button
            onClick={() => {
              onClose();
            }}
            className="w-full text-sm bg-gray-200 text-gray-800 py-2 px-4 rounded-full mt-2 hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserManageTeamModal;
